import { Box, Select, Typography, MenuItem, Skeleton } from "@mui/material";
import { Header } from "../../components/Header";
import { Footer } from "../../components/Footer";
import { Navigation } from "../../components/Navigation";
import { Body } from "../../components/Body";
import { brands, globalWordings } from "../../data";
import { Helmet } from "../../components/Helmet";
import { useState } from "react";
import { useBrandContext } from "../../App";
import { useParams } from "react-router-dom";
import React from "react";
import { AgeDisclaimer } from "../../components/AgeDisclaimer";
import { useLangRedirection } from "../../hooks/useLangRedirection";

export const Details = () => {
  useLangRedirection()
  const { lang } = useParams();
  const { brand } = useBrandContext();
  const { product } = useParams();
  const productData = brands[brand].products.find(p => p.id === product);
  const formats = productData.formats;
  const [format, setFormat] = useState(formats[0]);

  return (
    <Box>
      <Helmet title={`${brands[brand].name} | ${productData.name[lang]}`} />
      <Header />
      <Navigation
        title={productData.name[lang]}
        subtitle={globalWordings[lang].moreInformation}
        backButton={`/${lang}/${brand}`}
      />

      <Body>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          sx={{ width: "300px", mx: "auto" }}
        >
          <Typography variant="bold" fontSize={20} textAlign="center">
            {globalWordings[lang].chooseYourFormat}
          </Typography>
          <Select
            variant="standard"
            labelId="format-select-label"
            value={format}
            onChange={e => setFormat(e.target.value)}
            label={globalWordings[lang].chooseYourFormat}
          >
            {formats.map(f => (
              <MenuItem value={f}>{f.name[lang]}</MenuItem>
            ))}
          </Select>
        </Box>

        <Box
          display="flex"
          gap={{ xs: 2, md: 4 }}
          alignItems="start"
          mt={6}
          justifyContent={{ xs: "inherit", md: "center" }}
        >
          <React.Suspense
            fallback={
              <Skeleton
                variant="rectangular"
                width={{ xs: "50%", md: 165 }}
                height={200}
              />
            }
          >
            <Box
              component="img"
              src={format.image[lang]}
              loading="lazy"
              sx={{
                width: { xs: "50%", md: 165 },
              }}
              alt={`${format.name[lang]} format`}
            />
          </React.Suspense>
          <React.Suspense
            fallback={
              <Skeleton
                variant="rectangular"
                width={{ xs: "45%", md: 200 }}
                height={200}
              />
            }
          >
            <Box
              component="img"
              src={format.details[lang]}
              loading="lazy"
              alt={`${format.name[lang]} details`}
              sx={{
                width: { xs: "45%", md: 200 },
              }}
            />
          </React.Suspense>
        </Box>
      </Body>

      <Footer />
      <AgeDisclaimer />
    </Box>
  );
};
